import { createFileRoute } from '@tanstack/react-router'

import { PendingDeliveryRow, VenueTile } from '@/components/fotograf/knihovna'
import { SearchField, SectionLabel } from '@/components/shared'
import { PENDING, VENUES } from '@/mocks/fotograf/knihovna'

export const Route = createFileRoute('/fotograf/knihovna/')({
  head: () => ({ meta: [{ title: 'Knihovna · Aplikace Bitez' }] }),
  component: FotografKnihovna,
})

function FotografKnihovna() {
  return (
    <div className="px-4 pt-6 pb-6">
      <section className="animate-rise-up">
        <SectionLabel>Ještě odevzdat</SectionLabel>
        <div className="mt-3 space-y-3.5">
          {PENDING.map((delivery) => (
            <PendingDeliveryRow key={delivery.venue} delivery={delivery} />
          ))}
        </div>
      </section>

      <section className="mt-8">
        {/* Scoped to the venues, not to the whole screen: what he owes is a
            two-item work queue nobody searches, and it stays first. */}
        <SectionLabel>Vaše podniky</SectionLabel>
        <div className="mt-3">
          <SearchField placeholder="Hledat podnik" />
        </div>
        <div className="mt-4 grid grid-cols-2 gap-x-3 gap-y-5">
          {VENUES.map((library, index) => (
            <div
              key={library.venue}
              className="animate-rise-up"
              style={{ animationDelay: `${index * 60}ms` }}
            >
              <VenueTile library={library} />
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}
